<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="spaceTypeForm" (ngSubmit)="save()">
      <h1 *ngIf="source !== 'modal'" class="heading">
        {{spaceTypeId ? 'Edit' : 'Add'}}
      </h1>
      <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">
            Level of Service <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <select formControlName="los">
                <option value=""> Select Level of Service</option>
                <option *ngFor="let los of levelOfServices" value="{{los.id}}">{{(los.title | uppercase)}}</option>
              </select>
            </div>
            <div *ngIf="submitted && form.los.errors">
              <p *ngIf="form.los.errors.required" class="pt-1 text-red-600 text-xs">
                Level of Service is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Title <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="title" type="text" />
            </div>
            <div *ngIf="submitted && form.title.errors">
              <p *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                Title is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">Load Time <span class="text-red-600">* </span>
            <span class="text-gray-400">(mins)</span>
          </label>
          <div>
            <div>
              <input formControlName="loadTime" type="text" (keypress)="allowOnlyNumbers($event)" />
            </div>
            <div *ngIf="submitted && form.loadTime.errors">
              <p *ngIf="form.loadTime.errors.required" class="pt-1 text-red-600 text-xs">
                Load Time is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Unload Time <span class="text-red-600">* </span>
            <span class="text-gray-400">(mins)</span>
          </label>
          <div>
            <div>
              <input formControlName="unloadTime" type="text" (keypress)="allowOnlyNumbers($event)" />
            </div>
            <div *ngIf="submitted && form.unloadTime.errors">
              <p *ngIf="form.unloadTime.errors.required" class="pt-1 text-red-600 text-xs">
                Unload Time is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Status
          </label>
          <div>
            <div>
              <select formControlName="isActive">
                <option [value]="true">Active</option>
                <option [value]="false">Inactive</option>
              </select>
            </div>
            <div *ngIf="submitted && form.isActive.errors">
              <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                Status is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Description <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <textarea formControlName="description" name="" class="h-16"></textarea>
            </div>
            <div *ngIf="submitted && form.description.errors">
              <p *ngIf="form.description.errors.required" class="pt-1 text-red-600 text-xs">
                Description is required
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex space-x-4 sm:grid-cols-2">
        <div class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
          <label class="subheading">Wait & Return (WNR)</label>
          <div class="sm:col-span-2 flex items-center mt-6 space-x-2">
            <label
              class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <input type="checkbox" formControlName="wnr" class="peer sr-only" (change)="toggleWNR($event)"
                aria-checked="spaceTypeForm.get('wnr')?.value" />
              <span
                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                <span *ngIf="!spaceTypeForm.get('wnr')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                  aria-hidden="true">
                  <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span *ngIf="spaceTypeForm.get('wnr')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                  aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="h-3 w-3 text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                </span>
              </span>
            </label>
          </div>
        </div>
        <div class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
          <label class="subheading">Optional Weight</label>
          <div class="sm:col-span-2 flex items-center mt-6 space-x-2">
            <label
              class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <input type="checkbox" formControlName="isWeightOptional" class="peer sr-only" (change)="toggleWeight($event)"
                aria-checked="spaceTypeForm.get('isWeightOptional')?.value" />
              <span
                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                <span *ngIf="!spaceTypeForm.get('isWeightOptional')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                  aria-hidden="true">
                  <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                    <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                <span *ngIf="spaceTypeForm.get('isWeightOptional')?.value"
                  class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                  aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="h-3 w-3 text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                </span>
              </span>
            </label>
          </div>
        </div>
      
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">

        <button type="submit" class="btn btn-secondary">
          {{spaceTypeId ? 'Update' : 'Create'}}
        </button>
      </section>
    </form>
  </div>
</section>